import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGroups } from '../actions/groupActions';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from '@mui/material';

const GroupsList = ({ onManageChildren, onManageTeachers, onEdit }) => {
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.groups.groups);

  useEffect(() => {
    dispatch(fetchGroups());
  }, [dispatch]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="groups table">
        <TableHead>
          <TableRow>
            <TableCell>ID Grupă</TableCell>
            <TableCell>Nume Grupă</TableCell>
            <TableCell>Descriere</TableCell>
            <TableCell>Educatoare Asignate</TableCell>
            <TableCell>Acțiuni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {groups.map((group) => (
            <TableRow key={group.group_id}>
              <TableCell>{group.group_id}</TableCell>
              <TableCell>{group.group_name}</TableCell>
              <TableCell>{group.description}</TableCell>
              <TableCell>
                {group.teachers && group.teachers.length > 0 ? (
                  <List dense>
                    {group.teachers.map((teacher) => (
                      <ListItem key={teacher.user_id}>
                        <ListItemText primary={teacher.name} secondary={teacher.email} />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  'Fără educatoare asignați'
                )}
              </TableCell>
              <TableCell>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => onManageChildren(group)}
                    >
                      Gest. Copii
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => onManageTeachers(group)}
                    >
                      Gest. Educatoarea
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="outlined"
                      color="info"
                      onClick={() => onEdit(group)}
                    >
                      Editează
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GroupsList;
